import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import '../itinerary/itinerary.css';

export default function Safety({ type, data }) {
    return (
        <div className='detailsIncludedDiv'>
            <TripDetailsSubHeading text={type === 'safety' ? 'Safety Measures' : 'Things to Carry'} />
            <div className='includedpoints'>
                <ul>
                    {data?.map((inc, incIndex) => {
                        return (
                            <li key={incIndex} className='incText'>
                                ✅ {inc}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
